import React from 'react';
import Icon from '../../../components/AppIcon';

const PackageTrackingCard = ({ package: pkg, isSelected, onClick }) => {
  const getStatusConfig = (status) => {
    const configs = {
      in_transit: { label: 'En transit', color: 'bg-primary/10 text-primary', icon: 'Truck' },
      out_for_delivery: { label: 'En cours de livraison', color: 'bg-warning/10 text-warning', icon: 'MapPin' },
      delivered: { label: 'Livré', color: 'bg-success/10 text-success', icon: 'CheckCircle' },
      pending: { label: 'En attente', color: 'bg-gray-100 text-gray-700', icon: 'Clock' }
    };
    return configs?.[status] || configs?.pending;
  };

  const statusConfig = getStatusConfig(pkg?.status);

  const formatDate = (dateString) => {
    return new Date(dateString)?.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  const isUrgent = () => {
    const delivery = new Date(pkg?.estimatedDelivery);
    const today = new Date();
    const diffHours = Math.ceil((delivery - today) / (1000 * 60 * 60));
    return diffHours <= 24 && diffHours > 0;
  };

  return (
    <button
      onClick={onClick}
      className={`w-full text-left p-4 rounded-lg border-2 transition-all ${
        isSelected
          ? 'border-primary bg-primary/5 shadow-md'
          : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50'
      }`}
    >
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-1">
            <h4 className="font-semibold text-gray-900">{pkg?.packageNumber}</h4>
            {isUrgent() && (
              <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-error/10 text-error">
                <Icon name="Clock" size={10} />
                24h
              </span>
            )}
          </div>
          <p className="text-sm text-gray-600">{pkg?.patientName}</p>
        </div>
        <Icon name={statusConfig?.icon} size={20} className={statusConfig?.color?.split(' ')?.[1]} />
      </div>

      <div className="space-y-2">
        <div className="flex items-center justify-between text-xs">
          <span className="text-gray-600">Statut</span>
          <span className={`font-medium px-2 py-0.5 rounded-full ${statusConfig?.color}`}>
            {statusConfig?.label}
          </span>
        </div>

        <div className="flex items-center justify-between text-xs">
          <span className="text-gray-600">Livraison estimée</span>
          <span className="font-medium text-gray-900">{formatDate(pkg?.estimatedDelivery)}</span>
        </div>

        <div className="flex items-center gap-2 text-xs text-gray-600">
          <Icon name="MapPin" size={12} />
          <span className="truncate">{pkg?.currentLocation}</span>
        </div>
      </div>
    </button>
  );
};

export default PackageTrackingCard;